import {faSignInAlt} from "@fortawesome/free-solid-svg-icons";
import {Form, Formik, FormikValues} from "formik";
import {useCallback, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import ReactMarkdown from 'react-markdown';
import * as yup from 'yup';
import {useNotice} from "../Providers/NoticeProvider";
import FormControls from "./Fields/FormControls";
import StandardField from "./Fields/StandardField";

type Props = {
    handleSignInSubmit: (values: FormikValues) => void;
};



const InstructorSignInForm = ({
    handleSignInSubmit
}: Props) => {
    const [formIsModified, setFormIsModified] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [notice] = useNotice();

    const handleSetFormIsModified = useCallback(async (formIsModified: boolean) => {
        setFormIsModified(formIsModified);
    }, [setFormIsModified]);

    const initialValues = {
        username: '',
        password: ''
    };

    const schema = yup.object({
        username: yup.string().label('User name').required(),
        password: yup.string().label('Password').required()
    });

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={async (values) => {
                setLoading(true);
                await handleSignInSubmit(values);
                setLoading(false);
            }}
            enableReinitialize={true}
            validateOnChange={false}
        >
            {(props) => {
                return <>
                    <Form className="form-bg pt-2">
                        <Row className="mx-0 p-2">
                            <Col xs={12}>
                                <ReactMarkdown className="markdown">{notice.instructorLogInMessage}</ReactMarkdown>
                            </Col>
                            <Col xs={12}>
                                <StandardField
                                    name="username"
                                    type="text"
                                    label="Username:"
                                    disabled={false}
                                    handleSetFormIsModified={handleSetFormIsModified}
                                />
                            </Col>
                            <Col xs={12}>
                                <StandardField
                                    name="password"
                                    type="password"
                                    label="Password:"
                                    disabled={false}
                                    handleSetFormIsModified={handleSetFormIsModified}
                                />
                            </Col>
                        </Row>
                        <Row className="mx-1">
                            <Col xs={12}>
                                <hr />
                            </Col>
                        </Row>
                        <Row className="mx-0 p-2">
                            <Col xs={12} md={6} className="pt-1 d-flex flex-row justify-content-start align-items-center order-md-2">
                                <div style={{height: '46px'}}>
                                    <FormControls
                                        formIsModified={formIsModified}
                                        loading={loading}
                                        submitForm={props.submitForm}
                                        showSave={true}
                                        submitType="save"
                                        disableAutoSave={true}
                                        isValid={true}
                                        saveText="Login"
                                        saveTextAction="Authenticating"
                                        saveTextPast="Login"
                                        saveIcon={faSignInAlt}
                                    />
                                </div>
                            </Col>
                        </Row>

                    </Form>
                </>
            }}
        </Formik>
    );
};

export default InstructorSignInForm;
